import type { JSX } from '@builder.io/qwik';
import { component$, useContext } from '@builder.io/qwik';
import { cva } from 'class-variance-authority';
import { AppDataContext } from '~/contexts/AppDataContext';
import {
  getCSSHeightLgFactor,
  getCSSHeightMdFactor,
  getCSSHeightSmFactor,
} from '~/utilities/getCSS';
import { getScreenSizeObject } from '~/utilities/getScreenSizeObject';

const logoClasses = cva(
  'inline-flex items-center items-start duration-200 w-auto',
  {
    variants: {
      heightSm: getCSSHeightSmFactor(),
      heightMd: getCSSHeightMdFactor(),
      heightLg: getCSSHeightLgFactor(),
      location: {
        header: '',
        footer: 'h-6',
      },
    },
  }
);

const logoImageClasses = cva('h-full', {
  variants: {
    location: {
      header: 'min-w-[123px] md:max-w-none',
      footer: '',
    },
  },
});

export default component$(
  ({ location = 'header' }: { location: 'header' | 'footer' }): JSX.Element => {
    const {
      payloadToSSR: { layout },
      themeComponents,
    } = useContext(AppDataContext);

    const theLogoClasses =
      location === 'header'
        ? logoClasses({
            ...getScreenSizeObject(
              themeComponents.header,
              'firstRowLogoHeightIn',
              'Screen',
              'height'
            ),
          })
        : logoClasses({
            location,
          });

    return (
      <a class={theLogoClasses} href={layout[location].logo?.value.url}>
        <img
          class={logoImageClasses({
            location,
          })}
          width={undefined}
          height={undefined}
          src={`data:image/svg+xml,${encodeURIComponent(layout[location].logo?.value.src ?? '')}`}
          alt={layout[location].logo?.value.alt}
        />
      </a>
    );
  }
);
